import React from 'react';
import "bootstrap/dist/js/bootstrap.min.js";
import "@popperjs/core/dist/umd/popper.min.js";
import 'swiper/css';
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "./src/assets/css/plugins.css"
import "./src/assets/css/style.css"
import "./src/assets/css/custom.css"
import "./src/assets/css/responsive.css"
import "./src/assets/css/colors/aqua.css"
import "./src/assets/css/fonts/thicccboi.css"
import PostHogProvider from "./src/provider/PostHogProvider";

// in gatsby-browser.js
//  export function shouldUpdateScroll(prevRouterProps, { location }) {
//      window.scrollTo(0, 0)
//      const body = document.getElementsByTagName('body')[0]
//      body.scrollTop = 0
//      return false
//    }

export const wrapRootElement = ({ element }) => {
  return <PostHogProvider>{element}</PostHogProvider>;
};

  